import React, { useState } from 'react';
import DocumentTitle from 'react-document-title';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Button } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  Table,
  TableHeader,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import TableLayout from '../../components/TableLayout';
import useBaseTableProps from '../../hooks/useBaseTableProps';
import useIntl from '../../hooks/useIntl';

// hooks
import { useManageProperties } from './hooksV2';

import { TABLE_NAME } from './constantsV2';
import PropertyPortalModal from './PropertyPortalModal';
import generalMessages from '../App/messages';

const ManageProperties = ({ history }) => {
  const intl = useIntl();
  const baseTableProps = useBaseTableProps();
  const [propertyInfo, setPropertyInfo] = useState({});
  const [modal, setModal] = useState(false);
  const { contactUsWidget, adminEnhancementsPropertiesManagegroups } =
    useFlags();

  const resetModal = () => {
    setPropertyInfo({});
    setModal(false);
  };

  const handleEditPropertyPortal = (property) => {
    setPropertyInfo(property);
    setModal(true);
  };

  const onManagePropertyGroupsClick = () => {
    history.push('/manage-property-groups');
  };

  const {
    isLoading,
    name,
    rows,
    count,
    totalCount,
    order,
    orderBy,
    searchState,
    filterState,
    filterTypeState,
    dateState,
    filteredHeaders,
    handleSortChange,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleDateSubmit,
    selectedColumns,
    onCSVButtonClick,
    updateQuery,
    query,
    allColumnsHidden,
    columnOptions,
    handleColumnChange,
  } = useManageProperties({ intl, handleEditPropertyPortal, contactUsWidget });

  const updateProperties = () => {
    updateQuery({
      ...query,
      _refetch: Date.now(),
    });
  };

  return (
    <DocumentTitle data-testid={TABLE_NAME} title={'Manage Properties'}>
      <>
        <TableLayout name={TABLE_NAME} childrenElementsHeight={50 + 8}>
          {(tableHeight) => {
            return (
              <>
                <TableHeader
                  title={'Manage Properties'}
                  count={count}
                  totalCount={totalCount}
                  actions={
                    adminEnhancementsPropertiesManagegroups
                      ? [
                          <Button
                            key="manage-property-groups"
                            variant="shout"
                            onClick={onManagePropertyGroupsClick}
                          >
                            <FormattedMessage
                              {...generalMessages.managePropertyGroups}
                            />
                          </Button>,
                        ]
                      : []
                  }
                />
                <Table
                  {...baseTableProps}
                  allColumnsHidden={allColumnsHidden}
                  columnOptions={columnOptions}
                  count={count}
                  dateState={dateState}
                  filterState={filterState}
                  filterTypeState={filterTypeState}
                  handleColumnChange={handleColumnChange}
                  handleDateSubmit={handleDateSubmit}
                  handleFilterChange={handleFilterChange}
                  handleFilterTypeChange={handleFilterTypeChange}
                  handleSearchSubmit={handleSearchSubmit}
                  handleSortChange={handleSortChange}
                  headers={filteredHeaders}
                  height={tableHeight}
                  isLoading={isLoading}
                  name={name}
                  onCSVButtonClick={onCSVButtonClick}
                  order={order}
                  orderBy={orderBy}
                  rows={rows}
                  searchState={searchState}
                  selectedColumns={selectedColumns}
                  totalCount={totalCount}
                />
              </>
            );
          }}
        </TableLayout>
        <PropertyPortalModal
          show={modal}
          onHide={resetModal}
          property={propertyInfo}
          updateProperties={updateProperties}
        />
      </>
    </DocumentTitle>
  );
};

export default withRouter(ManageProperties);
